import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IGroup } from 'src/services/api/groups';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_GROUPS_PATH } from 'src/services/api/groups/constants';

export const useDeleteGroup = (id?: number) => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<void, IStandardErrorResponse>(
        async () => {
            const path = `${GET_GROUPS_PATH}/${id}`;
            await apiClient(path, { method: 'delete' });
        }, {
            onSuccess: () => {
                addNotification('Group deleted', 'success');

                queryClient.setQueryData<IGroup[]>(queryKeys.groups, (oldData) => {
                    if (!oldData) {
                        return [];
                    }

                    return oldData.filter((group) => group.id !== id);
                });

                queryClient.removeQueries([queryKeys.groups, id]);
            },
        });
};